export const X_APPLICATION_ID = 'Nautilus';

export function generateXCorrelationId(): string {
  const id = [Date.now(), Math.random() * 1e9, Math.random() * 1e9, Math.random() * 1e9]
    .map((num) => Math.round(num).toString(36))
    .join('-');

  return `${X_APPLICATION_ID}-${id}`;
}
